import React from "react";
import { Link, useNavigate } from "react-router-dom";

const roles = [
  { role: "engineer", title: "Engineer", text: "Record office attendance and submit daily work.", color: "bg-emerald-600 hover:bg-emerald-500" },
  { role: "lg_admin", title: "LG Admin", text: "Review attendance and approve work entries.", color: "bg-amber-500 hover:bg-amber-400 text-slate-950" },
  { role: "admin", title: "Genmech Admin", text: "Manage people, corrections, reporting, and audit history.", color: "bg-sky-600 hover:bg-sky-500" }
];

export default function AttendanceRoleSelect() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_#164e63,_#020617_50%,_#0f172a)] px-4 py-10 text-white">
      <div className="mx-auto max-w-6xl">
        <Link to="/" className="text-sm font-semibold text-slate-300 hover:text-white">← Main workspace</Link>
        <div className="mt-16 max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.32em] text-amber-300">Genmech Services · LG facility</p>
          <h1 className="mt-4 text-4xl font-black tracking-tight sm:text-5xl">Attendance and work approval</h1>
          <p className="mt-4 max-w-xl text-base leading-7 text-slate-300">A focused office-attendance workspace for the LG facility. No site-visit workflow is used here.</p>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {roles.map((item) => (
            <article key={item.role} className="rounded-3xl border border-white/15 bg-white/10 p-6 shadow-2xl backdrop-blur">
              <h2 className="text-2xl font-black">{item.title}</h2>
              <p className="mt-3 min-h-14 text-sm leading-6 text-slate-300">{item.text}</p>
              <button type="button" onClick={() => navigate(`/attendance/login/${item.role}`)} className={`mt-7 w-full rounded-2xl px-4 py-3 font-bold transition ${item.color}`}>Sign in as {item.title}</button>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
